<div class="col-12">
  <button
    [disabled]="proceedButtonDisabled"
    class="btn pointer-events-none"
    [ngStyle]="contentStyle"
    (click)="callFunctionByName()"
  >
    {{ title }}
  </button>
</div>
